const previewSample = require('./utility/previewSample.js')
const playSample = require('./utility/playSample.js')
const stopLoop = require('./utility/stopLoop.js')

module.exports = function(state, emitter) {

  emitter.on('previewsample', (sampleId) => {
    console.log('previewsample')
    let sample = state.samples.find(s => s.id === sampleId)
    previewSample(sample)
    emitter.emit('unfocus')
  })

  emitter.on('playsample', (sampleId) => {
    console.log('playsample')
    let sample = state.samples.find(s => s.id === sampleId)
    playSample(sample)
    emitter.emit('unfocus')
  })

  emitter.on('stoploop', (sampleId) => {
    console.log('stoploop')
    let sample = state.samples.find(s => s.id === sampleId)
    stopLoop(sample)
    emitter.emit('unfocus')
  })

  emitter.on('stopallsounds', () => {
    console.log('stopallsounds')
    Object.values(state.samples).forEach(s => s.file.stop())
    if (state.recordedSample) {
      state.recordedSample.stop()
    }
    emitter.emit('unfocus')
  })

}
